import { render, staticRenderFns } from "./ExplainConflictButton.vue?vue&type=template&id=452e1f0a&scoped=true&"
import script from "./ExplainConflictButton.vue?vue&type=script&lang=ts&"
export * from "./ExplainConflictButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e1f0a",
  null
  
)

export default component.exports